const loadAMap = () => {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
      return
    }
    const script = document.createElement("script")
    script.src = "https://webapi.amap.com/maps?v=1.4.15&key=46c9237014128b54f0164430a75a02ad&plugin=AMap.Geocoder"
    script.onload = () => {
      resolve(window.AMap)
    }
    script.onerror = () => {
      reject("地图加载失败，请重试")
    }
    document.body.appendChild(script)
  })
}

export default async function getLocation() {
  try {
    const AMap = await loadAMap()
    return new Promise((resolve, reject) => {
      AMap.plugin("AMap.Geolocation", () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 5000 //超过10秒后停止定位，默认：5s
        })
        geolocation.getCurrentPosition((status, result) => {
          if (status === "complete" && result.addressComponent) {
            result.addressComponent.formattedAddress = result.formattedAddress
            result.addressComponent.position = result.position
            resolve(result.addressComponent)
          } else {
            window.console.error(result)
            reject(result)
          }
        })
      })
    })
  } catch (err) {
    window.console.error(err)
  }
}
